import { notification } from 'antd'

import swal from 'sweetalert'
import { privateAPI, url } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'
import { getVendorDiscounts } from '../../redux'

// const vendorId = localStorage.getItem("vendorId");
// let token = jwt.verify(
//   localStorage.getItem("token"),
//   process.env.REACT_APP_DATA_DECRYPTION_KEY
// );
// const tokenData = decrypt(token.data);

export const createDiscount = (payload) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/create-discount`, {
      data: { ...payload },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch(getVendorDiscounts())
      swal('', resp.message, 'success')
    }
  }
}

export const toggleDiscount = (discountId, status) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/toggle-discount-status`, {
      data: {
        discountId,
        status,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch(getVendorDiscounts())
      swal('', resp.message, 'success')
    }
  }
}

export const sendToApp = (payload) => {
  return async () => {
    const res = await privateAPI.post(`${url}/send-to-app`, payload)
    if (res) {
      return true
      // dispatch(getVendorDiscounts());
      // swal("", res.data.message, "success");
    }
  }
}

export const getRemainingCoupons = (discountId, name) => {
  return async () => {
    const res = await privateAPI.post(`/general/get-discount-remainingCodes`, {
      data: {
        discountId,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      notification.success({
        message: `Discount ${name} has ${resp.remainingCodes} Promo Codes left.`,
        duration: 10,
        style: {
          fontSize: '1.25rem',
          fontWeight: 'bold',
          wordSpacing: '0.125rem',
        },
      })
    }
  }
}
